import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router";

import * as Api from "@/api";
import { setSystemSettingsPage } from "@/store/reducers/app";
import { toggleShowQueues, updateDashboardQueueOrder } from "@/store/reducers/dashboard";
import Valkyrie, { viArrowDownArrowUp, viCheck, viEyeSlash, viGear, viList } from "@sippy-platform/valkyrie";

import { DragDropProvider } from "@dnd-kit/react";
import { Button, IconButton, Stack, Tooltip, Typography } from "@mui/material";

import QueueCard from "./queuecard/QueueCard";

export default function QueueActivity() {
  const dispatch = useDispatch();

  const [dragMode, setDragMode] = useState(false);

  useEffect(() => {
    Promise.resolve(Api.getPossibleQueueMembers());
  }, []);

  const pbx = useSelector((state) => state.domain.pbx);
  const dashboardSettings = useSelector((state) => state.dashboard.find((_pbx) => _pbx.context === pbx.context));

  return (
    <Stack
      sx={{
        gap: 1,
      }}
    >
      <Stack
        direction="row"
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          gap: 1,
          height: 40,
        }}
      >
        <Typography variant="h5" component="h3">
          Queues
        </Typography>
        <Stack
          direction="row"
          sx={{
            gap: 0.5,
          }}
        >
          <Tooltip title={dragMode ? "Finish" : "Edit order"} placement="left">
            <IconButton
              onClick={() => setDragMode((prev) => !prev)}
              sx={[
                { color: "inherit" },
                dragMode && { bgcolor: "divider", border: (theme) => `1px solid ${theme.vars.palette.divider}` },
              ]}
            >
              <Valkyrie icon={dragMode ? viCheck : viArrowDownArrowUp} />
            </IconButton>
          </Tooltip>
        </Stack>
      </Stack>
      <Stack
        sx={{
          gap: 1,
          position: "relative",
        }}
      >
        {dashboardSettings.queueList.length ? (
          <DragDropProvider
            onDragEnd={(event) => dispatch(updateDashboardQueueOrder({ pbx: pbx.context, dndEvent: event }))}
          >
            {dashboardSettings.queueList.map((queue, index) => (
              <QueueCard id={queue.id} index={index} queue={queue} dragMode={dragMode} key={queue.id} />
            ))}
          </DragDropProvider>
        ) : (
          <Stack
            sx={{
              gap: 1,
            }}
          >
            <Typography>Set up queues to show on the dashboard.</Typography>
            <Stack
              direction="row"
              sx={{
                gap: 1,
                flexWrap: "wrap",
              }}
            >
              <Button
                onClick={() => dispatch(setSystemSettingsPage("dashboard"))}
                variant="contained"
                startIcon={<Valkyrie icon={viGear} />}
              >
                Manage dashboard queues
              </Button>
              <Button
                component={NavLink}
                to={"../call-flow/queues"}
                variant="contained"
                startIcon={<Valkyrie icon={viList} />}
              >
                Queues
              </Button>
              <Button
                onClick={() => dispatch(toggleShowQueues({ pbx: pbx.context }))}
                startIcon={<Valkyrie icon={viEyeSlash} />}
              >
                Hide queues
              </Button>
            </Stack>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
}
